module.exports = __webpack_public_path__ + "img/26.621eb421.png";